import type { ButtonHTMLAttributes, Ref } from 'react';
import { KebabIcon } from '@utils/icons';
import styles from './KebabButton.module.css';

export interface IKebabButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** The glyph's px size — 14 by default, as on the delivery board's header. */
  iconSize?: number;
  ref?: Ref<HTMLButtonElement>;
}

/**
 * The settings / overflow-menu trigger: the vertical three-dot kebab, in the
 * delivery board header's muted ghost look. Every settings button uses it —
 * never a gear, sliders, horizontal dots or a "⋮" glyph. Its base styles weigh
 * less than one class, so a call site's `className` (placement, size, a
 * toolbar's frame) always wins. Inside a Base UI menu: `render={<KebabButton … />}`.
 */
export function KebabButton({ iconSize = 14, type = 'button', className = '', ref, ...rest }: IKebabButtonProps) {
  return (
    <button ref={ref} type={type} className={`${styles.kebab} ${className}`} {...rest}>
      <KebabIcon size={iconSize} />
    </button>
  );
}
